import { useEffect } from 'react';

/**
 * Custom hook to manage SEO meta tags dynamically
 * More reliable than react-helmet for client-side only apps
 */
export const useSEO = ({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogUrl,
  ogType = 'website',
  robots = 'index, follow'
}) => {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Helper to update or create meta tag
    const setMeta = (name, content, property = false) => {
      if (!content) return;
      const attr = property ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Helper to update or create link tag
    const setLink = (rel, href) => {
      if (!href) return;
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', rel);
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    };

    // Set meta tags
    setMeta('description', description);
    setMeta('robots', robots);
    
    // Set Open Graph tags
    setMeta('og:title', ogTitle || title, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:url', ogUrl || canonical, true);
    setMeta('og:type', ogType, true);
    
    // Set canonical
    setLink('canonical', canonical);

    // Cleanup function
    return () => {
      // Optional: Reset to default values on unmount
      // document.title = 'DJ Nomad';
    };
  }, [title, description, canonical, ogTitle, ogDescription, ogUrl, ogType, robots]);
};

export default useSEO;
